import { ReactNode, useCallback } from 'react';
import { OptionsObject, SnackbarKey, useSnackbar } from 'notistack';

import {
  AUTO_HIDE_DURATION_TIME,
  NOTIFICATION_TYPES,
} from '@components/Notification';

import LeaveStyleStudioEventNotification from '@clients/ek/components/StyleStudio/LeaveStyleStudioEventNotification';

export interface ILeaveStyleStudioNotificationProps extends OptionsObject {
  message: string | ReactNode;
  type: NOTIFICATION_TYPES;
  closeManually?: boolean;
  onCancel: () => void;
  onLeave: () => void;
}

export type ShowLeaveStyleStudioEventNotificationType = (
  props: ILeaveStyleStudioNotificationProps,
) => SnackbarKey;

export type UseNotificationMessageType = () => {
  showLeaveStyleStudioEventNotification: ShowLeaveStyleStudioEventNotificationType;
};

const useNotificationMessage: UseNotificationMessageType = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showLeaveStyleStudioEventNotification: ShowLeaveStyleStudioEventNotificationType =
    useCallback(
      ({
        message,
        type,
        closeManually = false,
        onLeave,
        onCancel,
        ...options
      }) => {
        return enqueueSnackbar(JSON.stringify(message), {
          autoHideDuration: closeManually ? null : AUTO_HIDE_DURATION_TIME,
          preventDuplicate: true,
          content(key) {
            return LeaveStyleStudioEventNotification({
              id: key,
              message,
              type,
              onLeave,
              onCancel,
            });
          },
          ...options,
        });
      },
      [enqueueSnackbar],
    );

  return { showLeaveStyleStudioEventNotification };
};

export default useNotificationMessage;
